// Vendors
import { useManageState } from '@kubit/web-ui-components';
import { useState } from 'react';
import { useStylesV2 } from '@kubit/web-ui-product-components';
// Constants
import { STYLES_NAME } from '../../../constants/stylesName';
// Enumerations
import { TitleStateType, } from '../../../designSystem/reloaded/commons/components/variants';
const useTitleStylesHook = ({ ref, variant }) => {
    const variantStyles = useStylesV2({
        styleName: STYLES_NAME.TITLE,
        variantName: variant,
    });
    const { state, setRef } = useManageState({
        states: Object.values(TitleStateType),
        ref: ref,
    });
    const [styles, _] = useState(variantStyles?.[state]);
    return {
        setRef,
        styles,
    };
};
export { useTitleStylesHook };
//# sourceMappingURL=title-styles.hook.js.map